import React__default, { createContext } from 'react';

const ErrorIdContext = /*#__PURE__*/createContext(undefined);

/**
 * This wrapper component provides a prepended id
 * to all StormUI-based errors thrown within itself
 * via the context API.
\ */
const ErrorIdProvider = ({
  id,
  children
}) => /*#__PURE__*/React__default.createElement(ErrorIdContext.Provider, {
  value: {
    id
  }
}, children);

export { ErrorIdContext as E, ErrorIdProvider as a };
//# sourceMappingURL=ErrorIdProvider-D8z7hbHY.js.map
